module.exports = __webpack_public_path__ + "static/media/HOD.387554cb.png";